export class TourPlan {
    constructor() { }

    TrackingPoints: TrackingPoint[];
    PlanOfDay: { IsOptimized: boolean, Customers: Customer[] };
    Estimated: string;
}

export class TrackingPoint {
    constructor() { }

    Latitude: number;
    Longitude: number;
    Time: string;
    Standby: number;
}

export class Customer {

  constructor() { }

  CustomerId: string;
  Latitude: number;
  Longitude: number;
  MainCustomerId: string;
  Name: string;
  Outcomes: number[];
  Type: number;
  VisitHour: string;
  VisitRule: string;
  Duration: number;
  FixedStartDate: string;
  Name1: string;
  Name2: string;
  Origin: string;
  EventType: string;
  Position: number;
  IsPhoneCall: boolean;
  CustomerState: number;
  Priority: number;
}

export class User {
    constructor() { }

    Id: string;
    Username: string;
    AccountType: number;
    SalesRepId: string;
}

export class Users {
    constructor() { }

    Users: User[];
}

export class Route {
    constructor() {this.dailyMeetingMarkers = [], this.recurringMarkers = [], this.homeMarkers = [], this.userMarkers = [], this.oneShotMarkers = [] }
    dailyMeetingMarkers: google.maps.Marker[];
    recurringMarkers: google.maps.Marker[];
    homeMarkers: google.maps.Marker[];
    userMarkers: google.maps.Marker[];
    oneShotMarkers: google.maps.Marker[];
    Estimated: string;
}

export enum ShowCode {
    user = 1,
    oneShot = 2,
    reports = 4
}

export enum ViewTabs {
    Map = 0,
    WorkLoad = 1,
    VisitDistribution = 2,
    Kpi = 3
}

export class VisitDistributionRow {

    constructor() { }

    CustomerId: string;
    Name: string;
    Street: string;
    City: string;
    SmlPotential: number;
    SmlPotentialExhaustion: number;
    SmlClassCurrent: number;
    Status: number;
    VisitFrequencySystemProposed: number;
    VisitFrequencyBySalesRep: number;
    VisitDaySystemProposed: number;
    VisitDayBySalesRep: number;
    VisitRecurrenceRule: string;
    Active: number;
}

export class WorkloadTable {

    constructor() { }

    Weeks: Week[];
}

export class Week {

    constructor() { }

    Days: Day[];
    WeekNumber: number;
}

export class Day {

    constructor() { }

    Day: string;
    DayOfWeek: number;
    IsOptimized: boolean;
    Type: number;
    Visits: Customer[];
}

export enum UserFeatures {
    TrackingObserver = 1,
    MapView = 2,
    OwnAreasSalesreps = 3,
    OwnSalesreps = 4,
    AllSalesreps = 5
}

export enum SectionType {
  GooglePointInfo = 1,
  WorkLoadTable = 2
}

export class MeetingDisplayItem {
  name1: string;
  name2: string;
  customerId: string;
  origin: string;
  eventType: string;
  outcome?: string;
  icon_on_top_left: string;
  icon_on_bottom_left: string;
  visitRule: string;
  isPhoneCall?: boolean;
  duration?: number;
  fixedStartDate?: string;
  customerState: number;
  priority?: number;
}



export class Parameters {
  sectionType: SectionType;

  constructor(sectionType: SectionType = SectionType.GooglePointInfo) {
    this.sectionType = sectionType;
  }
}

export enum VisitFilterType {
  ShowUserPosition = 0,
  Outcome = 1,
  Oneshot = 2,
  Booster = 3,
  Priority = 4
}

export interface VisitEventType {
  key: string;   
  value?: string;
  selected: boolean;
  color?: string;
  visible: boolean;
}


export interface VisitSelectionEvent {
  allOptions: VisitEventType[];
  lastChanged: VisitEventType;
}

export interface MarkersEventParameters {
  markers: google.maps.Marker[];
  mapNumber: number;
}



// WEBPACK FOOTER //
// ./src/app/model/model.class.ts